import * as React from "react";
import { Grid, Button, TextField, Autocomplete } from "@mui/material";
import { useDispatch } from "react-redux";
import { LlamadaPrueba, FinLlamada } from "../../redux/actions/notificaciones";
import { useSelector } from "react-redux";
import { getEquipos } from "../../redux/selectors";
import { GetEquipos } from "../../redux/actions/equipos";

const Prueba = () => {
  const dispatch = useDispatch();
  const equipos = useSelector((state) => getEquipos(state));
  const [equipo, setEquipo] = React.useState(null);
  const [titulo, setTitulo] = React.useState("");
  const [texto, setTexto] = React.useState("");
  const [id, setId] = React.useState("");
  const [boton1, setBoton1] = React.useState("");
  const [boton2, setBoton2] = React.useState("");
  const [obs1, setObs1] = React.useState("");
  const [obs2, setObs2] = React.useState("");

  React.useEffect(() => {
    dispatch(GetEquipos());
  }, [dispatch]);

  return (
    <Grid
      container
      columnSpacing={4}
      rowSpacing={1}
      sx={{ justify: "center", alignItems: "center", p: 3 }}
    >
      <Grid size={12}>
        <Autocomplete
          options={equipos || []}
          getOptionLabel={(option) => option.DESCRIPCION}
          value={equipo}
          onChange={(event, newValue) => setEquipo(newValue)}
          renderInput={(params) => <TextField {...params} label="Equipo" />}
        />
      </Grid>
      <Grid size={6} sx={{ alignSelf: "flex-start" }}>
        <TextField
          label="Título"
          fullWidth
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
        />
      </Grid>
      <Grid size={6}>
        <TextField
          label="Texto"
          multiline
          rows={4}
          fullWidth
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
      </Grid>
      <Grid size={4}>
        <TextField
          label="ID"
          fullWidth
          value={id}
          onChange={(e) => setId(e.target.value)}
        />
      </Grid>
      <Grid size={4}>
        <TextField
          label="Botón 1"
          fullWidth
          value={boton1}
          onChange={(e) => setBoton1(e.target.value)}
        />
      </Grid>
      <Grid size={4}>
        <TextField
          label="Botón 2"
          fullWidth
          value={boton2}
          onChange={(e) => setBoton2(e.target.value)}
        />
      </Grid>
      <Grid size={4} />
      <Grid size={4}>
        <TextField
          label="Observacion 1"
          fullWidth
          value={obs1}
          onChange={(e) => setObs1(e.target.value)}
        />
      </Grid>
      <Grid size={4}>
        <TextField
          label="Observacion 2"
          fullWidth
          value={obs2}
          onChange={(e) => setObs2(e.target.value)}
        />
      </Grid>
      <Grid size={6} sx={{ justifyContent: "center", display: "flex" }}>
        <Button
          disabled={!equipo || !texto}
          onClick={() =>
            dispatch(
              LlamadaPrueba({
                TOKEN: equipo && equipo.TOKEN,
                TITULO: titulo,
                TEXTO: texto,
                ID: id,
                BOTON1: boton1,
                BOTON2: boton2,
                IDTEXTO1: obs1,
                IDTEXTO2: obs2,
              }),
            )
          }
        >
          Llamar
        </Button>
      </Grid>
      <Grid size={6} sx={{ justifyContent: "center", display: "flex" }}>
        <Button
          disabled={!equipo}
          onClick={() => dispatch(FinLlamada({ ID: equipo && equipo.TOKEN }))}
        >
          Borrar notificaciones
        </Button>
      </Grid>
    </Grid>
  );
};

export default Prueba;
